// extracted by css-extract-rspack-plugin
export default {"diffPreview":"FindingCommentPreview-module__diffPreview__jRgSE","commentBody":"FindingCommentPreview-module__commentBody__x8sDG"};